import { render, staticRenderFns } from "./RoiSelector.vue?vue&type=template&id=586d29df&scoped=true"
import script from "./RoiSelector.vue?vue&type=script&lang=js"
export * from "./RoiSelector.vue?vue&type=script&lang=js"
import style0 from "./RoiSelector.vue?vue&type=style&index=0&id=586d29df&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586d29df",
  null
  
)

export default component.exports